$(function() {
  // Find mobile device
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        iPad: function() {
        	return navigator.userAgent.match(/iPad/i);
    	},
    	mobile: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        },
        any: function() {
            return (isMobile.mobile() || isMobile.iPad());
        }
    };
  
  
  // Logo
  // For mob and Ipad
	$('#menu-toggle').click(function() {
		$('.mobile-nav-wrapper').toggleClass('opened');
      	$('#order-ur-box-nav').toggleClass('hide');
	});
  
//   home page main slider
  if($(".owl-carousel.home-main-slider").length) {
      $(".owl-carousel.home-main-slider").owlCarousel({
            navigation : true, // Show next and prev buttons
        	loop: true,
            slideSpeed : 300,
            paginationSpeed : 400,
            singleItem:true

            // "singleItem:true" is a shortcut for:
            // items : 1, 
            // itemsDesktop : false,
            // itemsDesktopSmall : false,
            // itemsTablet: false,
            // itemsMobile : false
        });
       $('.home-main-slider .owl-prev').html('<i class="fa fa-angle-left " aria-hidden="true"></i>');
       $('.home-main-slider .owl-next').html('<i class="fa fa-angle-right " aria-hidden="true"></i>');
  }
 
   if($(".owl-carousel.review-slider").length) {
      $(".owl-carousel.review-slider").owlCarousel({
            navigation : true,
        	loop: true,
            slideSpeed : 300,
            paginationSpeed : 400,
        	items:3,
        	slideBy: 3,
        	responsiveClass:true,
        	responsive:{
                0:{
                    items:1
                },
                768:{
                    items:3
                },
                1024:{
                    items:3
                }
            }
        });
       $('.review-slider .owl-prev').html('<i class="fa fa-angle-left " aria-hidden="true"></i>');
       $('.review-slider .owl-next').html('<i class="fa fa-angle-right " aria-hidden="true"></i>');
  }
 
  
  // GYB page
//   if($(".product-body .choose-snack").length) {
//     $("body").addClass('y-hide');
//   	$(".product-body .choose-snack").on('click change', function(e){
//     	$("body").removeClass('y-hide');
// 	});
//   }
if(!isMobile.mobile()){
  $('.middle-part-sec-2 li a.fancybox').click(function() {
  	var ele = $(this).parent().find('.product_details');
    ele.css({display: 'block', visibility: 'hidden'})
    var img_height = ele.find('.description-product-image').height();
    	ele.find('.product-description').css('max-height', img_height+'px');
    
  });
}
  
  
  	$('.box-button-radio input[type=radio]').on('change', function() {
      	  // enable body scroll
    	  $('body').css('overflow-y', 'initial');
      
      	  $('.cust-blur').addClass('hide');
      	  //$('.choose-from-main-snack-wrapper').css('z-index', '99');
          if($('.box-button-radio input[type=radio]').is(':checked')) {
            $('.box-button-radio input[type=radio]').prop('checked', false);
            $(this).prop('checked', true);
            
            //smooth scroll
            if($(this).data('snacktype') == '2') {
              var target = $('#snacktype-2-target');
              if( target.length ) {
                  event.preventDefault();
                  $('html, body').stop().animate({
                      scrollTop: target.offset().top
                  }, 1000);
              }
            }
          }
      // Show Cart icon
      $('.GYB-page-wrapper > div.cart').css('z-index', '1001');
      // avoid overlapping on GO To and NEXT button
      $('.choose-from-main-snack-wrapper').css('z-index', '99');
	});
//   surprise radio button
if(isMobile.mobile()){
  $('.box-button-radio.suprise-radio-btn input[type=radio]').click(function(){
    $('.box-button .choose-snack').click();
    $(".product-body").css('overflow','hidden');
  }); 
}
  
  
  $('.box-button .choose-snack').click( function() {
    $('.box-button-radio input[type=radio]').prop('checked', false);
  	$(this).parents('.fabbox-pick-choice').find('.box-button-radio input[type=radio]').prop('checked', true);
    $('.choose-from-main-snack-wrapper').css('z-index', '99');
    
    $('.cust-blur').addClass('hide');
    //smooth scroll
            if($(this).data('snacktype') == '2') {
              var target = $('#snacktype-2-target');
              if( target.length ) {
                  event.preventDefault();
                  $('html, body').stop().animate({
                      scrollTop: target.offset().top
                  }, 1000);
              }
            }
    // Show Cart icon
    $('.GYB-page-wrapper > div.cart').css('z-index', '1001');
    // avoid overlapping on GO To and NEXT button
    $('.choose-from-main-snack-wrapper').css('z-index', '99');
  });
  
  //Dont wory popup for mob
  if($('#dont-worries-mobile').length) {
    if(isMobile.mobile()){
      $("body").append("<div class='cust-blur GYB-bg-blur'></div>");
      $('#dont-worries-mobile').addClass('show');
      $('.choose-from-main-snack-wrapper').addClass('hide');
      $('body').css('overflow-y','hidden');
    }
    $('#dont-worries-mobile .ok-button').click(function() {
      $('#dont-worries-mobile').removeClass('show');
	  $('.cust-blur.GYB-bg-blur').css('background-color', 'rgba(255,255,255,0.7)');
      $('.choose-from-main-snack-wrapper').removeClass('hide');
      //$('body').css('overflow-y','initial');
    });
    
    //Surprise popup for mobile
    $(" .btn.choose-snack").click(function() {
      if($("#chosen-snack-type").val() == "1") {
       $('.cust-blur.GYB-bg-blur').removeClass('hide');
        $('.cust-blur.GYB-bg-blur').css('background-color', 'rgba(0,0,0,0.7)');
        $('.cust-blur.GYB-bg-blur').css('position', 'fixed');
        //$('.dont-worries-mobile.are-you-sure').addClass('show');
       
      }
     });
     $(".cancel-button.cust-cancel").click(function() {
        $('.cust-blur.GYB-bg-blur').addClass('hide');
     });
    $(".surprise-popup-close-button").click(function() {
        $('.cust-blur.GYB-bg-blur').addClass('hide');
      $('.dont-worries-mobile.are-you-sure').css({'display':'none'});
     });
   
   
  }
// call us in all snacks page
  if($('.collection-body').length){
	if(isMobile.mobile()){
	$('.span12.nav-table').after('<div class="callus-mobile all-snacks-page xs-only"><a href="tel:09819422433"> Call us </a> </div>');
	$('.span12.nav-table').after(' <div class="shipping-text all-snacks-page xs-only"> <span>Free Delivery all over India & <br/>COD available</span></div>');
    }};
  
 if($('.collection-body').length){
	$('.span12.nav-table').after('<div class="shipping-text snacks-page xs-hide">Free Delivery all over India & COD available</div>');
      
 };  
     
   if($('.cart-body, .product-body').length){
	if(isMobile.mobile()){
      $('.span2.nav-logo.clearfix').after('<div class="call-shipping-wrapper xs-only"><div class="callus-mobile top xs-only"> Call Us: <a href="tel:+919819422433">09819&nbsp;422&nbsp;433</a> </div><div class="shipping-text top  xs-only">Free Delivery all over India &<br/> COD available</div> </div>');
    }};
    
  // GYB page product main slider
    $('.product-carousel').slick({
      	dots: false,
      	speed: 25,
        infinite: true,
       	centerMode: true,
         centerPadding: '30px',
        slidesToShow: 1,
        slidesToScroll: 1,
      swipeToSlide: true
    }); 
  
//   if($('.GYB-page-wrapper').length){
//     $(document).on("pagehide", "div.GYB-page-wrapper", function(event){
//       console.log('DOM removed');
//     	$(event.target).remove();
//     });
//   }
  
//   remove call us onfocus on allergic textarea
  
//   customers-order-body page
  if (isMobile.mobile() && $('.customers-order-body').length) {
    $('.popup-cart,.pick-a-snacks-close,.pick-a-snack').click (function() {
      alert();
    	if($('.product-right-part').is(':visible')) 
            $('.call-shipping-wrapper').css('top', '10px');
        else 
          $('.call-shipping-wrapper').css('top', '38px');
    });
    
  }

});




